/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common text component
 */
import { Component, Input } from '@angular/core';
import { CommonTextData } from './common-text.component.model';

@Component({
  selector: 'wm-common-text',
  standalone:false,
  templateUrl: './common-text.component.html',
  styleUrls: ['./common-text.component.scss']
})
export class CommonTextComponent {
  private _data: CommonTextData = {
    text: '',
    fontFamily: 'roboto',
    textTransform:'none',
    required: false,
    fontSize: null,
    fontWeight: null,
    color: null
  };

  @Input({ required: true }) 
  set data(value: CommonTextData) {
    this._data = {
      fontFamily: 'roboto',
      text: '',
      textTransform:'none',
      required: false,
      ...value, // merge passed value with defaults
    };
  }

  get data(): CommonTextData {
    return this._data;
  }
}